import { resolveSemanticColor } from '@/theme/semanticTokens';
import { r, s } from '@/theme/tokens';
import type { SxProps, Theme } from '@/ui/primitives';

type ThemeSxObject = Exclude<SxProps<Theme>, readonly unknown[] | ((theme: Theme) => unknown)>;
type ThemeSxFn = (theme: Theme) => ThemeSxObject;

export const howFlowQaWorksDiagramFrameSx: ThemeSxFn = (theme) => ({
  border: `1px solid ${resolveSemanticColor(theme, 'border')}`,
  backgroundColor: resolveSemanticColor(theme, 'pageBg'),
  borderRadius: r('md'),
  p: s('md'),
  width: '100%',
});

export const howFlowQaWorksDiagramRowSx = {
  display: 'flex',
  alignItems: 'center',
} as const;

export const howFlowQaWorksDiagramPrefixSx: ThemeSxFn = (theme) => ({
  whiteSpace: 'pre',
  color: resolveSemanticColor(theme, 'textSecondary'),
});

export const buildHowFlowQaWorksDiagramNodeGroupSx = (
  hasMultipleNodes: boolean,
): ThemeSxObject => ({
  display: 'flex',
  alignItems: 'center',
  gap: hasMultipleNodes ? s('none') : s('sm'),
  flexWrap: 'wrap',
});

export const howFlowQaWorksDiagramNodeSx = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: s('sm'),
} as const;

export const howFlowQaWorksDiagramConnectorSx: ThemeSxFn = (theme) => ({
  color: resolveSemanticColor(theme, 'textSecondary'),
  whiteSpace: 'pre',
});
